import { useCallback, useRef } from 'react'

// Custom hook to debounce function calls
export const useDebounceFunc = (func, delay) => {
  const timeoutRef = useRef<NodeJS.Timeout | null>(null)

  return useCallback(
    (...args) => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }

      timeoutRef.current = setTimeout(() => {
        func(...args)
      }, delay)
    },
    [func, delay],
  )
}
